import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import Cookies from 'js-cookie';

export const useAuthValidation = () => {
  const [isLoading, setIsLoading] = useState(true);
  const router = useRouter();

  useEffect(() => {
    const token = Cookies.get('authToken');

    if (!token) {
      router.push('/login');
      return;
    }

    const validateToken = async () => {
      try {
        const res = await fetch('/api/validate-token');
        if (!res.ok) {
          throw new Error('Invalid');
        }

        const data = await res.json();

        console.log('User role:', data);

        if (data.role !== 'superAdmin' && data.role !== 'admin') {
          router.push('/login');
          return;
        }

        setIsLoading(false);
      } catch (err) {
        Cookies.remove('authToken');
        router.push('/login');
      }
    };

    setIsLoading(false);
    validateToken();
  }, []);

  return { isLoading };
};

export const useAuthValidateWithoutRedirect = () => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);

  useEffect(() => {
    const token = Cookies.get('authToken');
    if (!token) {
      setIsLoggedIn(false);
      return;
    }

    setIsLoggedIn(true);
  }, []);

  return { isLoggedIn };
};
